/* eslint-disable no-nested-ternary */
import { Route, Routes, Link, useLocation, useNavigate } from "react-router-dom";
import React, { useEffect, useMemo, useState } from "react";
import type { MenuProps } from "antd";
// DEVICE DETECT
import { isMobile } from "react-device-detect";
// ANT DESIGN COMPONENTS
import { Layout, Menu, Spin, Button, Badge } from "antd";
// I18N TRANSLATION
import { useTranslation } from "react-i18next";
// FONT AWESOME LIBRARY AND ICONS
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBuilding,
  faBuildingUser,
  faUsers,
  faUserShield,
  faKey,
  faTools,
  faGears,
  faServer,
  faElevator,
  faFileCircleCheck,
  faPlugCircleCheck,
  faTriangleExclamation,
  faChartPie,
  faTable,
  faUpDown,
  faPieChart,
  faGlobe,
  faMap,
  faChartLine,
  faFilePen,
  faTerminal,
} from "@fortawesome/free-solid-svg-icons";
// SWITCH THEME
import { useThemeSwitcher } from "react-css-theme-switcher";
// REDUX
import { useSelector, useDispatch } from "react-redux";
import {
  updateBreadcrumbTitle,
  updateUserLogged,
  updateTheme,
  updateSideBarCollapsed,
} from "../../redux/home/homeSlice";
import { updatePermissions } from "../../redux/users/userSlice";
import { setRoleScope } from "../../redux/scope/scopeSlice";
import { extractRoleScopeGrants } from "../../redux/scope/extractRoleScopeGrants";
import { useLazyGetCurrentLoggedUserQuery } from "../../redux/users/userAPI";
import { normalizeUserResponse } from "../../redux/users/normalizeUser";
import { updateOpenGlobalEndpointPanel } from "../../redux/monitoring/monitoringSlice";
import { useLiftWatchFleetQuery } from "../../redux/liftwatch/liftWatchAPI";
// COMPONENTS
import LayoutBreadcrumb from "./LayoutBreadcrumb";
import UsersPage from "../userManagement/users/UsersPage";
import OrganizationsPage from "../organizationManagement/organizations/OrganizationsPage";
import RolesPage from "../organizationManagement/roles/RolesPage";
import ApiClientsPage from "../organizationManagement/apiClients/ApiClientsPage";
import RolesCreate from "../organizationManagement/roles/RolesCreate";
import RolesEdit from "../organizationManagement/roles/RolesEdit";
import RolesView from "../organizationManagement/roles/RolesView";
import OffsetTypePage from "../tools/offsetType/OffsetTypePage";
import YourProfileDrawer from "./YourProfileDrawer";
import GlobalAlert from "./GlobalAlert";
import GlobalEndpointPanel from "../monitoringManagement/terminal/GlobalEndpointPanel";
import MonitoringPage from "../monitoringManagement/monitoring/MonitoringPage";
import LiftWatchPage from "../monitoringManagement/liftWatch/LiftWatchPage";
import NotFoundPage from "../unauthorized/NotFoundPage";
import BanksPage from "../edgeManagement/banks/BanksPage";
import BankActionsPage from "../edgeManagement/banksActions/BankActionsPage";
import BanksConfiguration from "../edgeManagement/banksConfiguration/BanksConfiguration";
import BanksFloorConfigurationPage from "../edgeManagement/banksFloorConfiguration/BanksFloorConfigurationPage";
import BanksLiftsPositionsPage from "../edgeManagement/banksLiftPositions/BanksLiftsPositionsPage";
import ServersPage from "../edgeManagement/servers/ServersPage";
import LiftsPage from "../edgeManagement/lifts/LiftsPage";
import ConfigurationFiles from "../configurationManagement/configurationFiles/ConfigurationFilesPage";
import DefinitionsPage from "../configurationManagement/definitions/DefinitionsPage";
import OffsetsPage from "../configurationManagement/offsets/OffsetsPage";
import DataBlocksPage from "../tools/dataBlocks/DataBlocksPage";
import ReportGeneralPage from "../reports/generalReports/ReportGeneralPage";
import ReportGeneralElevatorAvailability from "../reports/generalReports/ReportGeneralElevatorAvailability";
import ReportGeneralBeneficialUsage from "../reports/generalReports/ReportGeneralBeneficialUsage";
import ReportGeneralEscalatorAvailability from "../reports/generalReports/ReportGeneralEscalatorAvailability";
import ReportGeneralPerformance from "../reports/generalReports/ReportGeneralPerformance";
import ReportGeneralFireService from "../reports/generalReports/ReportGeneralFireService";
import ReportFaultGeneral from "../reports/fault/ReportFaultGeneral";
import ReportFaultLog from "../reports/fault/ReportFaultLog";
import ReportFaultRecent from "../reports/fault/ReportFaultRecent";
import ReportFaultRecentEscMov from "../reports/fault/ReportFaultRecentEscMov";
import ReportFaultChartDay from "../reports/fault/ReportFaultChartDay";
import ReportFaultChartDayEscMov from "../reports/fault/ReportFaultChartDayEscMov";
import ReportFaultChartByCar from "../reports/fault/ReportFaultChartByCar";
import ReportFaultChartByEscalator from "../reports/fault/ReportFaultChartByEscalator";
import ReportFaultChartFloor from "../reports/fault/ReportFaultChartFloor";
import ReportFaultChartByType from "../reports/fault/ReportFaultChartByType";
import ReportFaultChartFaultEscMov from "../reports/fault/ReportFaultChartFaultEscMov";
import ReportTrafficChartHallButtonCountsByFloor from "../reports/traffic/ReportTrafficChartHallButtonCountsByFloor";
import ReportTrafficChartHallButtonCountsByTimeOfDay from "../reports/traffic/ReportTrafficChartHallButtonCountsByTimeOfDay";
import ReportTrafficChartTripsToAndFromAFloor from "../reports/traffic/ReportTrafficChartTripsToAndFromAFloor";
import ReportTrafficDetailedSummary from "../reports/traffic/ReportTrafficDetailedSummary";
import ReportTrafficHallCallSummary from "../reports/traffic/ReportTrafficHallCallSummary";
import ReportTrafficChartAverageByFloor from "../reports/traffic/ReportTrafficChartAverageByFloor";
import ReportTrafficChartAverageByTimeOfDay from "../reports/traffic/ReportTrafficChartAverageByTimeOfDay";
import ReportTrafficChartDistributionByHourlyInterval from "../reports/traffic/ReportTrafficChartDistributionByHourlyInterval";
import ReportTrafficChartDistributionDetailedTotal from "../reports/traffic/ReportTrafficChartDistributionDetailedTotal";
import ReportTrafficChartDistributionDetailedDirection from "../reports/traffic/ReportTrafficChartDistributionDetailedDirection";
import ReportTrafficLongestWaitTimeList from "../reports/traffic/ReportTrafficLongestWaitTimeList";
import ReportPerformancePage from "../reports/performance/ReportPerformancePage";
import ReportOutOfServicePage from "../reports/outOfService/ReportOutOfServicePage";
import ReportTrafficGeneral from "../reports/traffic/ReportTrafficGeneral";
import ReportCarUsagePage from "../reports/carUsage/ReportCarUsagePage";
import ReportCarUseChartByHour from "../reports/carUsage/ReportCarUseChartByHour";
import ReportCarUseChartComparisons from "../reports/carUsage/ReportCarUseChartComparisons";
import ReportCarUseChartTimes from "../reports/carUsage/ReportCarUseChartTimes";
import ReportCarServiceGeneral from "../reports/carService/ReportCarServiceGeneral";
import ReportCarServiceChartServiceLog from "../reports/carService/ReportCarServiceChartServiceLog";
import ReportCarServiceServiceLog from "../reports/carService/ReportCarServiceServiceLog";
import ReportCarServiceLog from "../reports/carService/ReportCarServiceLog";
import ReportCarServiceStatistics from "../reports/carService/ReportCarServiceStatistics";
import ReportFaultFrequencyCar from "../reports/fault/ReportFaultFrequencyCar";
import ReportFaultFrequencyFault from "../reports/fault/ReportFaultFrequencyFault";
import ReportBeneficialPage from "../reports/beneficial/ReportBeneficialPage";
import AdaptersPage from "../edgeManagement/adapters/AdaptersPage";
import KeysBankPage from "../edgeManagement/keys/KeysBankPage";
import ChannelsPage from "../edgeManagement/channels/ChannelsPage";
import TermsAndConditions from "./TermsAndConditions";
import MessageTypePage from "../tools/messageType/MessageTypePage";
import MessagesPage from "../tools/messages/MessagesPage";
import ProtocolPage from "../tools/protocols/ProtocolPage";
import LeadingZeroesPage from "../tools/leadingZeroes/LeadingZeroesPage";
import GroupsPage from "../edgeManagement/groups/GroupsPage";
import MapViewPage from "../edgeManagement/map-view/MapViewPage";
import MapViewConfigurationPage from "../edgeManagement/map-view/MapViewConfigurationPage";
import DashboardPage from "../dashboard/DashboardPage";
import AdapterConfigurationIconDefinitionPage from "../edgeManagement/adaptersConfiguration/iconDefinition/IconDefinitionPage";
import AdapterConfigurationActionPage from "../edgeManagement/adaptersConfiguration/actions/ActionPage";
import AdapterConfigurationKeyPage from "../edgeManagement/adaptersConfiguration/keys/KeyPage";
import AdapterConfigurationOffsetPage from "../edgeManagement/adaptersConfiguration/offsets/OffsetPage";
import AdapterConfigurationFaultPage from "../edgeManagement/adaptersConfiguration/faults/FaultPage";
import AdaptersCreate from "../edgeManagement/adapters/AdaptersCreate";
import AdaptersDuplicate from "../edgeManagement/adapters/AdaptersDuplicate";
import AdaptersEdit from "../edgeManagement/adapters/AdaptersEdit";
import BanksEdit from "../edgeManagement/banks/BanksEdit";
import ServersCreate from "../edgeManagement/servers/ServersCreate";
import ServersEdit from "../edgeManagement/servers/ServersEdit";
import ChannelsEdit from "../edgeManagement/channels/ChannelsEdit";
import LiftsEdit from "../edgeManagement/lifts/LiftsEdit";
import SetupWizardPage from "../setupWizard/SetupWizardPage";
import SchemaEditorPage from "../setupWizard/editors/SchemaEditorPage";
import OrganizationDraftsPage from "../organizationManagement/drafts/OrganizationDraftsPage";
// AUTHORIZATION
import GETJwtToken, {
  clearOfflineSession,
  redirectToLogin,
} from "../../redux/authentication/authentication";
import { Permission, hasPermission } from "../../utils/validatePermissions";
import { isMasterAdmin } from "../../utils/isMasterAdmin";
import { isScreenAllowed } from "../../types/screenPermissions";
// STYLES
import logoBlack from "../../assets/logo/black-bg-lnlogo.png";
import logoWhite from "../../assets/logo/white-bg-lnlogo.png";
import mobileLogo from "../../assets/logo/lnLogo.png";
import UserNotFound from "./UserNotFound";
// UTILS
import { emptyFunctionDeclaration } from "../../utils/utils";
// INTERFACES
import { RootState } from "../../app/store";
import UsersCreate from "../userManagement/users/UsersCreate";
import UsersEdit from "../userManagement/users/UsersEdit";

const App = () => {
  // ************************************************ */
  // LOCAL STORAGE AND VARIABLES ******************** */
  const { Header, Content, Footer, Sider } = Layout;
  const { switcher, themes } = useThemeSwitcher();
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const [t] = useTranslation("global");
  const { theme, userLogged, sideBarCollapsed, globalRolName } = useSelector(
    (state: any) => state.home,
  );
  const { permissionSet } = useSelector((state: RootState) => state.user);
  // The header's org+role preview switcher (YourProfileDrawer) never touches
  // `userLogged` — it only dispatches `updatePermissions`/`globalRolName` —
  // so `userLogged.role.name` stays the REAL, authenticated account's role
  // for the whole session. Every `isMasterAdmin(...)`/`isScreenAllowed(...)`
  // call below used that raw `userLogged` for sidebar/route gating, which
  // meant a real master admin previewing e.g. "View Only" still tripped the
  // isMasterAdmin bypass on their own unchanged account and saw the full
  // menu regardless of what was being previewed (LNF sidebar-refresh bug).
  // Gate rendering on the PREVIEWED role instead: swap in `globalRolName`
  // when it differs from the real role, falling back to the real one before
  // any preview has run. Memoized so this useMemo/useSelector's referential
  // identity below only changes when the previewed role actually changes.
  const permissionUserLogged = useMemo(() => {
    if (!userLogged || !userLogged.role) return userLogged;
    const previewedRoleName = globalRolName || userLogged.role.name;
    if (previewedRoleName === userLogged.role.name) return userLogged;
    return { ...userLogged, role: { ...userLogged.role, name: previewedRoleName } };
  }, [userLogged, globalRolName]);

  // LiftWatch fleet health powers a sidebar attention badge. The fleet is a
  // cloud-side, master-admin-only surface, gated on the PREVIEWED role like
  // every other sidebar item above.
  const liftWatchAuthorized =
    process.env.REACT_APP_ENVIRONMENT !== "OFFLINE" && isMasterAdmin(permissionUserLogged);
  const { data: liftWatchFleet } = useLiftWatchFleetQuery(liftWatchAuthorized);
  const liftWatchAttention = useMemo(
    () =>
      liftWatchFleet?.servers.reduce(
        (count, server) =>
          count +
          Number(
            server.connection !== "awaiting_first_report" && server.overall_status !== "healthy",
          ),
        0,
      ) ?? 0,
    [liftWatchFleet],
  );
  const [current, setCurrent] = useState<any>("");
  const [openKeys, setOpenKeys] = useState([""]);
  const [isLoading, setIsLoading] = useState(false);
  const [localShowFullView, setLocalShowFullView] = useState(false);
  const rootSubmenuKeys = [
    "users",
    "monitoring",
    "dashboard",
    "map-view/map",
    "roles",
    "roles/permissions",
    "api-clients",
    "organizations",
    "edge-management/servers",
    "edge-management/banks",
    "edge-management/banks/control-actions",
    "edge-management/banks/floors-configuration",
    "edge-management/banks/lifts-positions",
    "edge-management/banks/configuration",
    "edge-management/lifts",
    "edge-management/adapters",
    "edge-management/adapters/edit",
    "edge-management/adapter/configuration-keys",
    "edge-management/adapter/configuration-offsets",
    "edge-management/adapter/configuration-actions",
    "edge-management/adapter/configuration-faults",
    "edge-management/adapter/configuration-icon-definitions",
    "edge-management/bank/keys",
    "edge-management/channels",
    "edge-management/groups",
    "edge-management/map-view",
    "offset-type-configuration",
    "configuration-catalog",
    "configuration-catalog/definitions",
    "configuration-catalog/offsets",
    "reports/report-general",
    "reports/general/report-elevator-availability",
    "reports/general/report-performance",
    "reports/general/report-beneficial-usage",
    "reports/general/report-escalator-availability",
    "reports/general/report-fire-service",
    "reports/report-fault",
    "reports/faults/report-general",
    "reports/faults/report-log",
    "reports/faults/report-recent",
    "reports/faults/chart-day",
    "reports/faults/chart-dayEscMov",
    "reports/faults/chart-fault",
    "reports/faults/chart-faultEscMov",
    "reports/faults/chart-floor",
    "reports/faults/chart-lift",
    "reports/faults/chart-liftEscMov",
    "reports/faults/report-car",
    "reports/faults/report-fault",
    "reports/report-traffic",
    "reports/report-car-user",
    "reports/car-use/chart-by-hour",
    "reports/car-use/chart-comparisons",
    "reports/car-use/chart-times",
    "reports/report-service",
    "reports/car-service/chart-service-log",
    "reports/car-service/report-log",
    "reports/car-service/report-statistics",
    "reports/report-beneficial",
    "reports/report-performance",
    "reports/report-out-of-service",
    "tools/data-blocks",
    "tools/offset-type-configuration",
    "tools/message-type",
    "tools/messages",
    "tools/protocols",
    "tools/leading-zeroes",
  ];
  const { showFullView, openGlobalEndpointPanel } = useSelector((state: any) => state.monitoring);

  // ************************************************ */
  // SERVICES AND API CALLS ************************* */
  const [
    triggerGetCurrentLoggedUserQuery,
    { isLoading: getCurrentLoggedUserIsLoading, isError: getCurrentLoggedUserIsError },
  ] = useLazyGetCurrentLoggedUserQuery();
  // ************************************************* */
  // FUNCTIONS *************************************** */
  const showIsLoading = () => {
    setIsLoading(true);
    setTimeout(() => {
      setIsLoading(false);
    }, 300);
  };

  const handleChangeHeaderTitle = (title: string) => {
    localStorage.setItem("headerTitle", title);
    dispatch(updateBreadcrumbTitle(title));
  };

  const getCurrentLoggedUser = async () => {
    let token: string | undefined;
    let response: any;
    try {
      // Online authentication
      token = await GETJwtToken();
      response = await triggerGetCurrentLoggedUserQuery({
        token,
      }).unwrap();
    } catch (err: any) {
      const status: number | undefined = err?.status;
      // Intentionally do NOT log err.data — the response body may contain
      // identifiers (cognito_id, user_id, email) that don't belong in the
      // browser console. Status code alone is sufficient to act on.
      if (status === 401 || status === 403) {
        // eslint-disable-next-line no-console
        console.warn(`getCurrentLoggedUser: auth rejected (${status}), redirecting to login`);
        try {
          localStorage.removeItem("access_token");
          localStorage.removeItem("refresh_token");
        } catch {
          // localStorage may be unavailable in some test environments
        }
        clearOfflineSession();
        // Full-page navigation, deliberately — see redirectToLogin's comment.
        // react-router's navigate() resolved /login against the PRIVATE route
        // table and rendered NotFoundPage at /v{N}/login, which is how a role
        // that could not read /api/users/me was reported as a 404 at login.
        redirectToLogin();
        return;
      }
      // eslint-disable-next-line no-console
      console.error(`getCurrentLoggedUser failed with status ${status ?? "unknown"}`);
      return;
    }

    if (response && response.data) {
      const raw = response.data.user ?? response.data;
      const user = normalizeUserResponse(raw);
      dispatch(updateUserLogged(user));
      const userTheme = user.prefTheme;
      if (userTheme && userTheme !== "") {
        switcher({ theme: themes[userTheme] });
        localStorage.setItem("theme", userTheme);
        dispatch(updateTheme(userTheme));
      }
      const menu = raw.roleMenu ?? (raw.role && raw.role.menu);
      if (menu) {
        dispatch(updatePermissions(menu));
      }
      // Populate entity-scoped grants immediately after menu permissions.
      // extractRoleScopeGrants tolerates both FlatBuffer camelCase and
      // JSON snake_case shapes, and returns empty arrays (allow-all) when
      // the permission vectors are absent.
      dispatch(setRoleScope(extractRoleScopeGrants(raw)));
    }
  };

  const onChangeTab: any = (e: any) => {
    if (e.key) {
      setCurrent(e.key.toString());
    }
  };
  const onOpenChange = (keys: any) => {
    const latestOpenKey = keys.find((key: any) => openKeys.indexOf(key) === -1);
    if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
      setOpenKeys(keys);
    } else {
      setOpenKeys(latestOpenKey ? [latestOpenKey] : []);
    }
  };

  const updateSideBarTab = (current_: string, key_: string) => {
    handleChangeHeaderTitle(current_);
    setCurrent(current_);
    setOpenKeys([key_]);
  };

  const updateSideBarTabCascader = (current_: string, keys_: string[]) => {
    handleChangeHeaderTitle(current_);
    setCurrent(current_);
    setOpenKeys(keys_);
  };

  const onClickLiftnetLogo = () => {
    navigate({
      pathname: "/monitoring",
    });
  };

  // ************************************************* */
  // USE EFFECT ************************************** */
  useEffect(() => {
    getCurrentLoggedUser();
    const headerTitle = localStorage.getItem("headerTitle");
    setCurrent(headerTitle);
    if (
      headerTitle === "roles" ||
      headerTitle === "roleCreate" ||
      headerTitle === "organizations" ||
      headerTitle === "users" ||
      headerTitle === "apiClients" ||
      headerTitle === "rolesAndPermissions"
    ) {
      setOpenKeys(["organizationManagement"]);
    } else if (
      headerTitle === "servers" ||
      headerTitle === "serverEdit" ||
      headerTitle === "banks" ||
      headerTitle === "floorsConfiguration" ||
      headerTitle === "liftsPositions" ||
      headerTitle === "controlActions" ||
      headerTitle === "lifts" ||
      headerTitle === "adapters" ||
      headerTitle === "configuration" ||
      headerTitle === "configurationCatalog" ||
      headerTitle === "channels" ||
      headerTitle === "groups"
    ) {
      setOpenKeys(["edgeManagement"]);
    } else if (
      headerTitle === "notificationsBanks" ||
      headerTitle === "notifications" ||
      headerTitle === "notificationsUsers" ||
      headerTitle === "notificationsSchedules"
    ) {
      setOpenKeys(["notifications"]);
    } else if (
      headerTitle === "offsetTypeConfiguration" ||
      headerTitle === "dataBlocks" ||
      headerTitle === "vendors" ||
      headerTitle === "permissions" ||
      headerTitle === "actions" ||
      headerTitle === "messageType" ||
      headerTitle === "messages" ||
      headerTitle === "protocols" ||
      headerTitle === "leading-zeroes"
    ) {
      setOpenKeys(["tools"]);
    } else if (
      headerTitle === "reportGeneral" ||
      headerTitle === "reportFault" ||
      headerTitle === "reportTraffic" ||
      headerTitle === "reportCarUsage" ||
      headerTitle === "reportService" ||
      headerTitle === "reportBeneficial" ||
      headerTitle === "reportPerformance" ||
      headerTitle === "reportOutOfService"
    ) {
      setOpenKeys(["reports"]);
    } else if (
      headerTitle === "reportFaultsReportGeneral" ||
      headerTitle === "reportFaultsReportLog" ||
      headerTitle === "reportFaultsReportRecent" ||
      headerTitle === "reportFaultsReportRecentEscMov" ||
      headerTitle === "reportFaultsChartDay" ||
      headerTitle === "reportFaultsChartDayEscMov" ||
      headerTitle === "reportFaultsChartFault" ||
      headerTitle === "reportFaultsChartFaultEscMov" ||
      headerTitle === "reportFaultsChartFloor" ||
      headerTitle === "reportFaultsChartLift" ||
      headerTitle === "reportFaultsChartLiftEscMov" ||
      headerTitle === "reportFaultsFrequencyReportCar" ||
      headerTitle === "reportFaultsFrequencyReportFault"
    ) {
      setOpenKeys(["reports", "faults"]);
    } else if (
      headerTitle === "reportTrafficChartHallButtonCountsByFloor" ||
      headerTitle === "reportTrafficChartHallButtonCountsByTimeOfDay" ||
      headerTitle === "reportTrafficChartTripsToAndFromAFloor" ||
      headerTitle === "reportTrafficReportDetailedSummary" ||
      headerTitle === "reportTrafficReportHallCallSummaryReport" ||
      headerTitle === "reportTrafficChartAverageByFloor" ||
      headerTitle === "reportTrafficChartAverageByTimeOfDay" ||
      headerTitle === "reportTrafficChartDistributionByHourlyInterval" ||
      headerTitle === "reportTrafficChartDistributionDetailedTotal" ||
      headerTitle === "reportTrafficChartDistributionDetailedDirection" ||
      headerTitle === "reportTrafficReportLongestWaitTimeList"
    ) {
      setOpenKeys(["reports", "carUse"]);
    } else if (
      headerTitle === "reportCarUseChartByHour" ||
      headerTitle === "reportCarUseChartComparisons" ||
      headerTitle === "reportCarUseChartTimes"
    ) {
      setOpenKeys(["reports", "carUse"]);
    } else if (
      headerTitle === "reportCarServiceChartServiceLog" ||
      headerTitle === "reportCarServiceServiceLog" ||
      headerTitle === "reportCarServiceReportLog" ||
      headerTitle === "reportCarServiceReportStatistics"
    ) {
      setOpenKeys(["reports", "carService"]);
    } else if (
      headerTitle === "reportGeneralReportCurrentOutOfservice" ||
      headerTitle === "reportGeneralReportPerformance" ||
      headerTitle === "reportGeneralReportBeneficialUsage" ||
      headerTitle === "reportGeneralReportEscalatorInUse" ||
      headerTitle === "reportGeneralReportFireService"
    ) {
      setOpenKeys(["reports", "general"]);
    }
  }, []);

  useEffect(() => {
    if (localStorage.getItem("headerTitle") === "monitoring") {
      setCurrent("monitoring");
    }
  }, [localStorage.getItem("headerTitle")]);

  useEffect(() => {
    if (location && location.pathname) {
      if (location.pathname.startsWith("/organization-management/users/create")) {
        updateSideBarTab("userCreate", "organizationManagement");
        return;
      }

      if (location.pathname.startsWith("/organization-management/users/edit/")) {
        updateSideBarTab("userCreate", "organizationManagement");
        return;
      }

      if (location.pathname.startsWith("/organization-management/roles/create")) {
        updateSideBarTab("roleCreate", "organizationManagement");
        return;
      }

      if (location.pathname.startsWith("/organization-management/roles/edit/")) {
        updateSideBarTab("roleCreate", "organizationManagement");
        return;
      }

      if (location.pathname.startsWith("/organization-management/roles/view/")) {
        updateSideBarTab("roleCreate", "organizationManagement");
        return;
      }

      if (location.pathname.startsWith("/edge-management/servers/create")) {
        updateSideBarTab("serverCreate", "edgeManagement");
        return;
      }

      if (location.pathname.startsWith("/edge-management/adapters/create")) {
        updateSideBarTab("adapterCreate", "edgeManagement");
        return;
      }

      if (location.pathname.startsWith("/edge-management/adapters/edit/")) {
        updateSideBarTab("adapterEdit", "edgeManagement");
        return;
      }

      if (location.pathname.startsWith("/edge-management/adapters/duplicate/")) {
        updateSideBarTab("adapterEdit", "edgeManagement");
        return;
      }

      if (location.pathname.startsWith("/edge-management/server/edit")) {
        updateSideBarTab("serverEdit", "edgeManagement");
        return;
      }

      switch (location.pathname) {
        case "/monitoring":
          updateSideBarTab("monitoring", "monitoring");
          break;
        case "/monitoring/lift-watch":
          updateSideBarTab("liftWatch", "monitoring");
          break;
        case "/dashboard/overview":
          updateSideBarTab("dashboard", "dashboard");
          break;
        case "/map-view/map":
          updateSideBarTab("map", "mapView");
          break;
        case "/organization-management/roles":
          updateSideBarTab("roles", "organizationManagement");
          break;
        case "/organization-management/roles/permissions":
          updateSideBarTab("rolesAndPermissions", "organizationManagement");
          break;
        case "/organization-management/organizations":
          updateSideBarTab("organizations", "organizationManagement");
          break;
        case "/organization-management/users":
          updateSideBarTab("users", "organizationManagement");
          break;
        case "/organization-management/drafts":
          updateSideBarTab("drafts", "organizationManagement");
          break;
        case "/organization-management/api-clients":
          updateSideBarTab("apiClients", "organizationManagement");
          break;
        case "/organization-management/setup-wizard":
          updateSideBarTab("drafts", "organizationManagement");
          break;
        case "/edge-management/servers":
          updateSideBarTab("servers", "edgeManagement");
          break;
        case "/edge-management/adapters":
          updateSideBarTab("adapters", "edgeManagement");
          break;
        case "/edge-management/adapter/configuration-keys":
          updateSideBarTab("adapterConfigurationKeys", "edgeManagement");
          break;
        case "/edge-management/adapter/configuration-faults":
          updateSideBarTab("adapterConfigurationFaults", "edgeManagement");
          break;
        case "/edge-management/adapter/configuration-actions":
          updateSideBarTab("adapterConfigurationActions", "edgeManagement");
          break;
        case "/edge-management/adapter/configuration-offsets":
          updateSideBarTab("adapterConfigurationOffsets", "edgeManagement");
          break;
        case "/edge-management/adapter/configuration-icon-definitions":
          updateSideBarTab("adapterConfigurationIconDefinitions", "edgeManagement");
          break;
        case "/edge-management/bank/keys":
          updateSideBarTab("keys", "edgeManagement");
          break;
        case "/edge-management/channels":
          updateSideBarTab("channels", "edgeManagement");
          break;
        case "/edge-management/banks":
          updateSideBarTab("banks", "edgeManagement");
          break;
        case "/edge-management/banks/control-actions":
          updateSideBarTab("controlActions", "edgeManagement");
          break;
        case "/edge-management/banks/configuration":
          updateSideBarTab("banks", "edgeManagement");
          break;
        case "/edge-management/lifts":
          updateSideBarTab("lifts", "edgeManagement");
          break;
        case "/edge-management/configuration-catalog":
          updateSideBarTab("configurationCatalog", "edgeManagement");
          break;
        case "/edge-management/groups":
          updateSideBarTab("groups", "edgeManagement");
          break;
        case "/tools/offset-type-configuration":
          updateSideBarTab("offsetTypeConfiguration", "tools");
          break;
        case "/tools/data-blocks-configuration":
          updateSideBarTab("dataBlocksConfiguration", "tools");
          break;
        case "/tools/messages-type":
          updateSideBarTab("messageType", "tools");
          break;
        case "/tools/protocols":
          updateSideBarTab("protocols", "tools");
          break;
        case "/tools/leading-zeroes":
          updateSideBarTab("leadingZeroes", "tools");
          break;
        case "/tools/messages":
          updateSideBarTab("messages", "tools");
          break;
        case "/reports/report-general":
          updateSideBarTab("reportGeneral", "reports");
          break;
        case "/reports/report-fault":
          updateSideBarTab("reportFault", "reports");
          break;
        case "/reports/general/report-elevator-availability":
          updateSideBarTabCascader("reportGeneralReportCurrentOutOfService", [
            "reports",
            "general",
          ]);
          break;
        case "/reports/general/report-performance":
          updateSideBarTabCascader("reportGeneralReportPerformance", ["reports", "general"]);
          break;
        case "/reports/general/report-beneficial-usage":
          updateSideBarTabCascader("reportGeneralReportBeneficialUsage", ["reports", "general"]);
          break;
        case "/reports/general/report-escalator-availability":
          updateSideBarTabCascader("reportGeneralReportEscalatorInUse", ["reports", "general"]);
          break;
        case "/reports/general/report-fire-service":
          updateSideBarTabCascader("reportGeneralReportFireService", ["reports", "general"]);
          break;
        case "/reports/faults/report-recent":
          updateSideBarTabCascader("reportFaultsReportRecentFault", ["reports", "faults"]);
          break;
        case "/reports/faults/report-recent-escmov":
          updateSideBarTabCascader("reportFaultsReportRecentFaultEscMov", ["reports", "faults"]);
          break;
        case "/reports/faults/report-log":
          updateSideBarTabCascader("reportFaultsReportLog", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-lift":
          updateSideBarTabCascader("reportFaultsChartLift", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-lift-escmov":
          updateSideBarTabCascader("reportFaultsChartLiftEscMov", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-floor":
          updateSideBarTabCascader("reportFaultsChartFloor", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-day":
          updateSideBarTabCascader("reportFaultsChartDay", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-day-escmov":
          updateSideBarTabCascader("reportFaultsChartDayEscMov", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-fault":
          updateSideBarTabCascader("reportFaultsChartFault", ["reports", "faults"]);
          break;
        case "/reports/faults/chart-fault-escmov":
          updateSideBarTabCascader("reportFaultsChartFaultEscMov", ["reports", "faults"]);
          break;
        case "/reports/faults/report-car":
          updateSideBarTabCascader("reportFaultsFrequencyReportCar", ["reports", "faults"]);
          break;
        case "/reports/faults/report-fault":
          updateSideBarTabCascader("reportFaultsFrequencyReportFault", ["reports", "faults"]);
          break;
        case "/reports/traffic/chart-hall-button-counts-by-floor":
          updateSideBarTabCascader("reportTrafficChartHallButtonCountsByFloor", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/chart-hall-button-counts-by-time-of-day":
          updateSideBarTabCascader("reportTrafficChartHallButtonCountsByTimeOfDay", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/chart-trips-to-and-from-a-floor":
          updateSideBarTabCascader("reportTrafficChartTripsToAndFromAFloor", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/report-detailed-summary":
          updateSideBarTabCascader("reportTrafficReportDetailedSummary", ["reports", "traffic"]);
          break;
        case "/reports/traffic/report-hall-call-summary":
          updateSideBarTabCascader("reportTrafficReportHallCallSummaryReport", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/chart-average-by-floor":
          updateSideBarTabCascader("reportTrafficChartAverageByFloor", ["reports", "traffic"]);
          break;
        case "/reports/traffic/chart-average-by-time-of-day":
          updateSideBarTabCascader("reportTrafficChartAverageByTimeOfDay", ["reports", "traffic"]);
          break;
        case "/reports/traffic/chart-distribution-by-hourly-interval":
          updateSideBarTabCascader("reportTrafficChartDistributionByHourlyInterval", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/chart-distribution-detailed-total":
          updateSideBarTabCascader("reportTrafficChartDistributionDetailedTotal", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/chart-distribution-detailed-direction":
          updateSideBarTabCascader("reportTrafficChartDistributionDetailedDirection", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/traffic/report-longest-wait-time-list":
          updateSideBarTabCascader("reportTrafficReportLongestWaitTimeList", [
            "reports",
            "traffic",
          ]);
          break;
        case "/reports/report-performance":
          updateSideBarTab("reportPerformance", "reports");
          break;
        case "/reports/report-out-of-service":
          updateSideBarTab("reportOutOfService", "reports");
          break;
        case "/reports/report-traffic":
          updateSideBarTab("reportTraffic", "reports");
          break;
        case "/reports/report-car-user":
          updateSideBarTab("reportCarUsage", "reports");
          break;
        case "/reports/car-use/chart-by-hour":
          updateSideBarTabCascader("reportCarUseChartByHour", ["reports", "carUse"]);
          break;
        case "/reports/car-use/chart-comparisons":
          updateSideBarTabCascader("reportCarUseChartComparisons", ["reports", "carUse"]);
          break;
        case "/reports/car-use/chart-times":
          updateSideBarTabCascader("reportCarUseChartTimes", ["reports", "carUse"]);
          break;
        case "/reports/report-service":
          updateSideBarTab("reportService", "reports");
          break;
        case "/reports/car-service/chart-service-log":
          updateSideBarTabCascader("reportCarServiceChartServiceLog", ["reports", "carService"]);
          break;
        case "/reports/car-service/report-service-log":
          updateSideBarTabCascader("reportCarServiceServiceLog", ["reports", "carService"]);
          break;
        case "/reports/car-service/report-log":
          updateSideBarTabCascader("reportCarServiceReportLog", ["reports", "carService"]);
          break;
        case "/reports/car-service/report-statistics":
          updateSideBarTabCascader("reportCarServiceReportStatistics", ["reports", "carService"]);
          break;

        case "/reports/report-beneficial":
          updateSideBarTab("reportBeneficial", "reports");
          break;
        default:
          break;
      }
    }
  }, [location]);

  useEffect(() => {
    showIsLoading();
    setTimeout(() => {
      setLocalShowFullView(showFullView);
    }, 100);
  }, [showFullView]);

  useEffect(() => {
    if (getCurrentLoggedUserIsError) {
      // signOut();
    }
  }, [getCurrentLoggedUserIsError]);

  // ************************************************ */
  // SIDEBAR MENU ITEMS (memoised — rebuild only when t, permissions, or */
  // handleChangeHeaderTitle change). Replaces the deprecated children-based */
  // Menu API with the `items` prop. */
  // ************************************************ */
  const menuItems = useMemo<NonNullable<MenuProps["items"]>>(() => {
    type Item = NonNullable<MenuProps["items"]>[number];

    /** Build a leaf Menu item that navigates via react-router Link. */
    const linkItem = (
      key: string,
      icon: React.ReactNode,
      to: string,
      labelText: React.ReactNode,
      headerTitleKey: string = key,
    ): Item => ({
      key,
      icon,
      label: (
        <Link
          onClick={() => {
            handleChangeHeaderTitle(headerTitleKey);
          }}
          to={to}
        >
          <span>{labelText}</span>
        </Link>
      ),
    });

    const items: Item[] = [];

    // MONITORING — gated by view-monitoring-dashboard. LiftCloud grants that key
    // to every role that has not decided it (a catalogue rule), so the role's
    // menu carries it on unless an administrator switched it off.
    if (isScreenAllowed("monitoring", permissionUserLogged, permissionSet ?? [])) {
      items.push(
        linkItem(
          "monitoring",
          <FontAwesomeIcon className="generalStyles__info" icon={faChartLine} />,
          "/monitoring",
          t("sideBar.monitoring"),
        ),
      );
    }
    if (liftWatchAuthorized) {
      items.push(
        linkItem(
          "liftWatch",
          <FontAwesomeIcon className="generalStyles__info" icon={faServer} />,
          "/monitoring/lift-watch",
          <>
            {t("sideBar.liftWatch")}{" "}
            <Badge
              count={liftWatchAttention}
              overflowCount={999}
              title={t("liftWatch.attentionCount", { count: liftWatchAttention })}
            />
          </>,
        ),
      );
    }

    // ORGANIZATION MANAGEMENT
    //
    // MASTER ADMIN bypasses this section toggle. Without it, a master admin
    // whose stored role-menu snapshot predates ViewOrganizationManagement
    // being granted -- the same staleness class documented on
    // useEffectivePermission above, which once broke the bank/lift control
    // panels for master admin -- would never reach the children below,
    // including the MASTER-ADMIN-aware Users check just past them.
    if (
      isMasterAdmin(permissionUserLogged) ||
      hasPermission(Permission.ViewOrganizationManagement, permissionSet ?? []) ||
      // The setup wizard is opened from the Organizations screen below.
      hasPermission(Permission.WizardInstallerAccess, permissionSet ?? [])
    ) {
      const children: Item[] = [];
      if (isScreenAllowed("organizations", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "organizations",
            <FontAwesomeIcon className="generalStyles__info" icon={faBuilding} />,
            "/organization-management/organizations",
            t("sideBar.organizations"),
          ),
        );
      }
      if (isScreenAllowed("drafts", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "drafts",
            <FontAwesomeIcon className="generalStyles__info" icon={faFilePen} />,
            "/organization-management/drafts",
            "Drafts",
          ),
        );
      }
      if (isScreenAllowed("roles", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "roles",
            <FontAwesomeIcon className="generalStyles__info" icon={faUserShield} />,
            "/organization-management/roles",
            t("sideBar.roles"),
          ),
        );
      }
      // API clients (LIFT-1098): the credentials other systems use on the
      // external API, and the role each acts as there.
      if (isScreenAllowed("api-clients", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "apiClients",
            <FontAwesomeIcon className="generalStyles__info" icon={faKey} />,
            "/organization-management/api-clients",
            t("sideBar.apiClients"),
          ),
        );
      }
      if (isScreenAllowed("users", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "view-organization-management-users",
            <FontAwesomeIcon className="generalStyles__info" icon={faUsers} />,
            "/users-management/users",
            t("sideBar.users"),
            "users",
          ),
        );
      }
      // A section with no visible child is never pushed — the container
      // permission (ViewOrganizationManagement) can stay granted on its
      // own even after every individual screen under it is hidden (each
      // reads its OWN tree_key), which would otherwise leave an empty
      // "Organization Management" group in the sidebar with nothing to
      // click.
      if (children.length > 0) {
        items.push({
          key: "organizationManagement",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faBuildingUser} />,
          label: t("sideBar.organizationManagement"),
          children,
        });
      }
    }

    // EDGE MANAGEMENT
    //
    // MASTER ADMIN bypasses this section toggle -- same reasoning as
    // Organization Management above.
    if (
      isMasterAdmin(permissionUserLogged) ||
      hasPermission(Permission.ViewEdgeManagement, permissionSet ?? [])
    ) {
      const children: Item[] = [];
      if (isScreenAllowed("adapters", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "adapters",
            <FontAwesomeIcon className="generalStyles__info" icon={faPlugCircleCheck} />,
            "/edge-management/adapters",
            t("sideBar.adapters"),
          ),
        );
      }
      if (isScreenAllowed("map-view", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "mapView",
            <FontAwesomeIcon className="generalStyles__info" icon={faMap} />,
            "/edge-management/map-view",
            t("sideBar.mapView"),
          ),
        );
      }
      if (isScreenAllowed("servers", permissionUserLogged, permissionSet ?? [])) {
        children.push(
          linkItem(
            "servers",
            <FontAwesomeIcon className="generalStyles__info" icon={faServer} />,
            "/edge-management/servers",
            t("sideBar.servers"),
          ),
        );
      }
      // Same "no visible child -> no empty group" rule as Organization
      // Management above (ViewEdgeManagement can stay granted through
      // banks/channels/lifts/groups/catalog even once Adapters/Map View/
      // Servers are all hidden, since it's the OR of every action under
      // it, not just these 3).
      if (children.length > 0) {
        items.push({
          key: "edgeManagement",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faGears} />,
          label: t("header.edgeManagement"),
          children,
        });
      }
    }

    // REPORTS (nested SubMenus)
    //
    // MASTER ADMIN bypasses this section toggle -- same reasoning as
    // Organization Management and Edge Management above.
    if (
      isMasterAdmin(permissionUserLogged) ||
      hasPermission(Permission.ViewReportManagement, permissionSet ?? [])
    ) {
      const generalChildren: Item[] = [];
      if (
        isScreenAllowed(
          "general-report-elevator-availability",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        generalChildren.push(
          linkItem(
            "reportGeneralReportCurrentOutOfService",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/general/report-elevator-availability",
            t("general.currentOutOfService"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "general-report-escalator-availability",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        generalChildren.push(
          linkItem(
            "reportGeneralReportEscalatorInUse",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/general/report-escalator-availability",
            t("general.escalatorInUse"),
          ),
        );
      }
      if (
        isScreenAllowed("general-report-performance", permissionUserLogged, permissionSet ?? [])
      ) {
        generalChildren.push(
          linkItem(
            "reportGeneralReportPerformance",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/general/report-performance",
            t("general.performance"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "general-report-beneficial-usage",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        generalChildren.push(
          linkItem(
            "reportGeneralReportBeneficialUsage",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/general/report-beneficial-usage",
            t("general.beneficialUsage"),
          ),
        );
      }
      if (
        isScreenAllowed("general-report-fire-service", permissionUserLogged, permissionSet ?? [])
      ) {
        generalChildren.push(
          linkItem(
            "reportGeneralReportFireService",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/general/report-fire-service",
            t("general.fireService"),
          ),
        );
      }

      const faultsChildren: Item[] = [];
      if (isScreenAllowed("faults-report-recent", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsReportRecentFault",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/faults/report-recent",
            t("general.recentFaults"),
            "reportFaultsReportRecent",
          ),
        );
      }
      if (
        isScreenAllowed("faults-report-recent-escmov", permissionUserLogged, permissionSet ?? [])
      ) {
        faultsChildren.push(
          linkItem(
            "reportFaultsReportRecentFaultEscMov",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/faults/report-recent-escmov",
            t("general.recentFaultsEscMov"),
            "reportFaultsReportRecent",
          ),
        );
      }
      if (isScreenAllowed("faults-report-log", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsReportLog",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/faults/report-log",
            t("general.faultLogByBank"),
          ),
        );
      }
      if (isScreenAllowed("faults-report-car", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsFrequencyReportCar",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/faults/report-car",
            t("general.frequencyByCar"),
          ),
        );
      }
      if (isScreenAllowed("faults-report-fault", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsFrequencyReportFault",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/faults/report-fault",
            t("general.frequencyByFault"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-lift", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartLift",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-lift",
            t("general.faultByLift"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-lift-escmov", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartLiftEscMov",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-lift-escmov",
            t("general.faultByLiftEscMov"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-floor", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartFloor",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-floor",
            t("general.faultByFloor"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-day", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartDay",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-day",
            t("general.faultByDay"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-day-escmov", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartDayEscMov",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-day-escmov",
            t("general.faultByDayEscMov"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-fault", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartFault",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-fault",
            t("general.faultByType"),
          ),
        );
      }
      if (isScreenAllowed("faults-chart-fault-escmov", permissionUserLogged, permissionSet ?? [])) {
        faultsChildren.push(
          linkItem(
            "reportFaultsChartFaultEscMov",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/faults/chart-fault-escmov",
            t("general.faultByTypeEscMov"),
          ),
        );
      }

      const trafficChildren: Item[] = [];
      if (
        isScreenAllowed(
          "traffic-report-detailed-summary",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficReportDetailedSummary",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/traffic/report-detailed-summary",
            t("general.detailedSummaryReport"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-report-hall-call-summary",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficReportHallCallSummaryReport",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/traffic/report-hall-call-summary",
            t("general.hallCallSummaryReport"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-report-longest-wait-time-list",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficReportLongestWaitTimeList",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/traffic/report-longest-wait-time-list",
            t("general.longestWaitTimes"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-trips-to-and-from-a-floor",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartTripsToAndFromAFloor",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-trips-to-and-from-a-floor",
            t("general.tripsToAndFromFloor"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-hall-button-counts-by-floor",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartHallButtonCountsByFloor",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-hall-button-counts-by-floor",
            t("general.byFloor"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-hall-button-counts-by-time-of-day",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartHallButtonCountsByTimeOfDay",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-hall-button-counts-by-time-of-day",
            t("general.byTimeOfDay"),
          ),
        );
      }
      if (
        isScreenAllowed("traffic-chart-average-by-floor", permissionUserLogged, permissionSet ?? [])
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartAverageByFloor",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-average-by-floor",
            t("general.averageByFloor"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-average-by-time-of-day",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartAverageByTimeOfDay",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-average-by-time-of-day",
            t("general.averageByTimeOfDay"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-distribution-by-hourly-interval",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartDistributionByHourlyInterval",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-distribution-by-hourly-interval",
            t("general.distributionByHourlyInterval"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-distribution-detailed-total",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartDistributionDetailedTotal",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-distribution-detailed-total",
            t("general.distributionDetailedTotal"),
          ),
        );
      }
      if (
        isScreenAllowed(
          "traffic-chart-distribution-detailed-direction",
          permissionUserLogged,
          permissionSet ?? [],
        )
      ) {
        trafficChildren.push(
          linkItem(
            "reportTrafficChartDistributionDetailedDirection",
            <FontAwesomeIcon className="generalStyles__info" icon={faPieChart} />,
            "/reports/traffic/chart-distribution-detailed-direction",
            t("general.distributionDetailedDirection"),
          ),
        );
      }

      const carUseChildren: Item[] = [];
      if (isScreenAllowed("car-use-chart-by-hour", permissionUserLogged, permissionSet ?? [])) {
        carUseChildren.push(
          linkItem(
            "reportCarUseChartByHour",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/car-use/chart-by-hour",
            t("general.carUseByHour"),
          ),
        );
      }
      if (isScreenAllowed("car-use-chart-comparisons", permissionUserLogged, permissionSet ?? [])) {
        carUseChildren.push(
          linkItem(
            "reportCarUseChartComparisons",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/car-use/chart-comparisons",
            t("general.carUseComparisons"),
          ),
        );
      }
      if (isScreenAllowed("car-use-chart-times", permissionUserLogged, permissionSet ?? [])) {
        carUseChildren.push(
          linkItem(
            "reportCarUseChartTimes",
            <FontAwesomeIcon className="generalStyles__info" icon={faChartPie} />,
            "/reports/car-use/chart-times",
            t("general.carUseTimes"),
          ),
        );
      }

      const carServiceChildren: Item[] = [];
      if (
        isScreenAllowed("car-service-report-service-log", permissionUserLogged, permissionSet ?? [])
      ) {
        carServiceChildren.push(
          linkItem(
            "reportCarServiceServiceLog",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/car-service/report-service-log",
            t("general.serviceLog"),
          ),
        );
      }
      if (isScreenAllowed("car-service-report-log", permissionUserLogged, permissionSet ?? [])) {
        carServiceChildren.push(
          linkItem(
            "reportCarServiceReportLog",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/car-service/report-log",
            t("general.log"),
          ),
        );
      }
      if (
        isScreenAllowed("car-service-report-statistics", permissionUserLogged, permissionSet ?? [])
      ) {
        carServiceChildren.push(
          linkItem(
            "reportCarServiceReportStatistics",
            <FontAwesomeIcon className="generalStyles__info" icon={faTable} />,
            "/reports/car-service/report-statistics",
            t("general.statistics"),
          ),
        );
      }

      // Each Reports sub-group (General/Faults/Traffic/Car Use/Service
      // Logs) is a pure visual grouping with no permission of its own —
      // dropped here when every one of its own leaves is hidden, same
      // "no visible child -> no empty group" rule as Organization
      // Management / Edge Management above, just one level deeper.
      const reportsGroups: {
        key: string;
        icon: React.ReactNode;
        label: string;
        children: Item[];
      }[] = [
        {
          key: "general",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faGlobe} />,
          label: "General",
          children: generalChildren,
        },
        {
          key: "faults",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faTriangleExclamation} />,
          label: "Faults",
          children: faultsChildren,
        },
        {
          key: "traffic",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faUpDown} />,
          label: "Traffic",
          children: trafficChildren,
        },
        {
          key: "carUse",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faElevator} />,
          label: "Car Use",
          children: carUseChildren,
        },
        {
          key: "carService",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faTools} />,
          label: "Service Logs",
          children: carServiceChildren,
        },
      ];
      const reportsChildren: Item[] = reportsGroups.filter((group) => group.children.length > 0);

      // The "Reports" section itself is dropped once every one of its
      // sub-groups is empty (ViewReportManagement can stay granted on its
      // own the same way the other two container permissions can).
      if (reportsChildren.length > 0) {
        items.push({
          key: "reports",
          icon: <FontAwesomeIcon className="generalStyles__info" icon={faFileCircleCheck} />,
          label: "Reports",
          children: reportsChildren,
        });
      }
    }

    return items;
  }, [
    t,
    permissionSet,
    permissionUserLogged,
    handleChangeHeaderTitle,
    liftWatchAuthorized,
    liftWatchAttention,
  ]);

  // ************************************************ */
  // COMPONENT ************************************** */
  return (
    <Spin spinning={isLoading || getCurrentLoggedUserIsLoading}>
      {!isLoading && (
        <>
          <Layout className="generalStyles__layoutHeight">
            {/** ******************************************************* */}
            {/** SIDE BAR */}
            {((!localShowFullView && localStorage.getItem("headerTitle") === "monitoring") ||
              localStorage.getItem("headerTitle") !== "monitoring") && (
              <Sider
                collapsible
                collapsed={sideBarCollapsed || isMobile}
                onCollapse={(value) => dispatch(updateSideBarCollapsed(value))}
                width="290"
              >
                <div
                  className="logo"
                  role="button"
                  tabIndex={0}
                  onClick={() => {
                    onClickLiftnetLogo();
                  }}
                  onKeyDown={emptyFunctionDeclaration}
                  aria-label="Liftnet's logo"
                >
                  <img
                    src={isMobile ? mobileLogo : theme === "light" ? logoWhite : logoBlack}
                    alt=""
                    className={isMobile ? "layout__sideBarMobileLogo" : "layout__sideBarLogo"}
                  />
                </div>
                <Menu
                  defaultSelectedKeys={[current]}
                  defaultOpenKeys={openKeys}
                  selectedKeys={[current]}
                  openKeys={openKeys}
                  mode="inline"
                  onClick={onChangeTab}
                  onOpenChange={onOpenChange}
                  items={menuItems}
                />
              </Sider>
            )}
            {/** ******************************************************* */}
            {/** LAYOUT */}
            <Layout
              style={{
                overflowX: "auto",
              }}
            >
              {/** ******************************************************* */}
              {/** HEADER */}
              {((!localShowFullView && localStorage.getItem("headerTitle") === "monitoring") ||
                localStorage.getItem("headerTitle") !== "monitoring") && (
                <Header className="generalStyles__header">
                  <div className="generalStyles__spaceBetween">
                    <div />
                    <div>
                      <YourProfileDrawer />
                    </div>
                  </div>
                </Header>
              )}
              {/** ******************************************************* */}
              {/** CONTENT */}
              <Content>
                <LayoutBreadcrumb />
                <div
                  className={isMobile ? "layout__contentPageMobile" : "layout__contentPage"}
                  style={{ paddingBottom: "var(--endpoint-panel-height, 0px)" }}
                >
                  <Routes>
                    <Route path="*" element={<NotFoundPage />} />
                    <Route path="" element={<MonitoringPage />} />
                    <Route path="monitoring" element={<MonitoringPage />} />
                    <Route path="lift-watch" element={<LiftWatchPage />} />
                    <Route path="overview" element={<DashboardPage />} />
                    <Route path="map" element={<MapViewPage />} />
                    <Route path="users" element={<UsersPage />} />
                    <Route
                      path="users/create"
                      element={
                        isScreenAllowed(
                          "users-create",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <UsersCreate />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route
                      path="users/edit/:id"
                      element={
                        isScreenAllowed(
                          "users-edit-id",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <UsersEdit />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route path="organizations" element={<OrganizationsPage />} />
                    <Route path="drafts" element={<OrganizationDraftsPage />} />
                    <Route path="roles" element={<RolesPage />} />
                    <Route path="api-clients" element={<ApiClientsPage />} />
                    <Route
                      path="roles/create"
                      element={
                        isScreenAllowed(
                          "roles-create",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <RolesCreate />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route
                      path="roles/edit/:id"
                      element={
                        isScreenAllowed(
                          "roles-edit-id",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <RolesEdit />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    {/** Read-only permissions view — gated by RolesView, not
                        RolesUpdate: it is the action offered for a
                        master-organization role to users who may look but not
                        edit. */}
                    <Route
                      path="roles/view/:id"
                      element={
                        isScreenAllowed(
                          "roles-view-id",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <RolesView />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route path="offset-type-configuration" element={<OffsetTypePage />} />
                    <Route path="data-blocks-configuration" element={<DataBlocksPage />} />
                    <Route path="messages-type" element={<MessageTypePage />} />
                    <Route path="messages" element={<MessagesPage />} />
                    <Route path="protocols" element={<ProtocolPage />} />
                    <Route path="leading-zeroes" element={<LeadingZeroesPage />} />
                    <Route path="configuration-catalog" element={<ConfigurationFiles />} />
                    <Route path="configuration-catalog/definitions" element={<DefinitionsPage />} />
                    <Route path="configuration-catalog/offsets" element={<OffsetsPage />} />
                    <Route path="banks" element={<BanksPage />} />
                    <Route
                      path="banks/floors-configuration"
                      element={<BanksFloorConfigurationPage />}
                    />
                    <Route path="banks/lifts-positions" element={<BanksLiftsPositionsPage />} />
                    <Route path="banks/control-actions" element={<BankActionsPage />} />
                    <Route path="banks/configuration" element={<BanksConfiguration />} />
                    <Route path="bank/keys" element={<KeysBankPage />} />
                    <Route path="bank/edit" element={<BanksEdit />} />
                    <Route path="server/edit" element={<ServersEdit />} />
                    <Route path="channel/edit" element={<ChannelsEdit />} />
                    <Route path="lift/edit" element={<LiftsEdit />} />
                    <Route
                      path="servers/floors-configuration"
                      element={<BanksFloorConfigurationPage />}
                    />
                    <Route path="servers" element={<ServersPage />} />
                    <Route
                      path="servers/create"
                      element={
                        isScreenAllowed(
                          "servers-create",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <ServersCreate />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route path="lifts" element={<LiftsPage />} />
                    <Route path="adapters" element={<AdaptersPage />} />
                    <Route
                      path="adapters/create"
                      element={
                        isScreenAllowed(
                          "adapters-create",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <AdaptersCreate />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route
                      path="adapters/edit/:adapterId"
                      element={
                        isScreenAllowed(
                          "adapters-edit-adapterid",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <AdaptersEdit />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route
                      path="adapters/duplicate/:adapterId"
                      element={
                        isScreenAllowed(
                          "adapters-duplicate-adapterid",
                          permissionUserLogged,
                          permissionSet ?? [],
                        ) ? (
                          <AdaptersDuplicate />
                        ) : (
                          <NotFoundPage />
                        )
                      }
                    />
                    <Route path="setup-wizard" element={<SetupWizardPage />} />
                    <Route path="schema-editor" element={<SchemaEditorPage />} />
                    <Route
                      path="adapter/configuration-keys"
                      element={<AdapterConfigurationKeyPage />}
                    />
                    <Route
                      path="adapter/configuration-actions"
                      element={<AdapterConfigurationActionPage />}
                    />
                    <Route
                      path="adapter/configuration-faults"
                      element={<AdapterConfigurationFaultPage />}
                    />
                    <Route
                      path="adapter/configuration-offsets"
                      element={<AdapterConfigurationOffsetPage />}
                    />
                    <Route
                      path="adapter/configuration-icon-definitions"
                      element={<AdapterConfigurationIconDefinitionPage />}
                    />
                    <Route path="map-view" element={<MapViewPage />} />
                    <Route path="map-view/configuration" element={<MapViewConfigurationPage />} />
                    <Route path="servers/channels" element={<ChannelsPage />} />
                    <Route path="channels" element={<ChannelsPage />} />
                    <Route path="groups" element={<GroupsPage />} />
                    <Route path="report-general" element={<ReportGeneralPage />} />
                    <Route path="report-fault" element={<ReportFaultGeneral />} />
                    <Route
                      path="general/report-elevator-availability"
                      element={<ReportGeneralElevatorAvailability />}
                    />
                    <Route
                      path="general/report-performance"
                      element={<ReportGeneralPerformance />}
                    />
                    <Route
                      path="general/report-beneficial-usage"
                      element={<ReportGeneralBeneficialUsage />}
                    />
                    <Route
                      path="general/report-escalator-availability"
                      element={<ReportGeneralEscalatorAvailability />}
                    />
                    <Route
                      path="general/report-fire-service"
                      element={<ReportGeneralFireService />}
                    />
                    <Route path="faults/report-log" element={<ReportFaultLog />} />
                    <Route path="faults/report-recent" element={<ReportFaultRecent />} />
                    <Route
                      path="faults/report-recent-escmov"
                      element={<ReportFaultRecentEscMov />}
                    />
                    <Route path="faults/chart-day" element={<ReportFaultChartDay />} />
                    <Route path="faults/chart-day-escmov" element={<ReportFaultChartDayEscMov />} />
                    <Route path="faults/chart-floor" element={<ReportFaultChartFloor />} />
                    <Route path="faults/chart-lift" element={<ReportFaultChartByCar />} />
                    <Route
                      path="faults/chart-lift-escmov"
                      element={<ReportFaultChartByEscalator />}
                    />
                    <Route path="faults/chart-fault" element={<ReportFaultChartByType />} />
                    <Route
                      path="faults/chart-fault-escmov"
                      element={<ReportFaultChartFaultEscMov />}
                    />
                    <Route path="faults/report-car" element={<ReportFaultFrequencyCar />} />
                    <Route path="faults/report-fault" element={<ReportFaultFrequencyFault />} />
                    <Route
                      path="traffic/chart-hall-button-counts-by-floor"
                      element={<ReportTrafficChartHallButtonCountsByFloor />}
                    />
                    <Route
                      path="traffic/chart-hall-button-counts-by-time-of-day"
                      element={<ReportTrafficChartHallButtonCountsByTimeOfDay />}
                    />
                    <Route
                      path="traffic/chart-trips-to-and-from-a-floor"
                      element={<ReportTrafficChartTripsToAndFromAFloor />}
                    />
                    <Route
                      path="traffic/report-detailed-summary"
                      element={<ReportTrafficDetailedSummary />}
                    />
                    <Route
                      path="traffic/report-hall-call-summary"
                      element={<ReportTrafficHallCallSummary />}
                    />
                    <Route
                      path="traffic/chart-average-by-floor"
                      element={<ReportTrafficChartAverageByFloor />}
                    />
                    <Route
                      path="traffic/chart-average-by-time-of-day"
                      element={<ReportTrafficChartAverageByTimeOfDay />}
                    />
                    <Route
                      path="traffic/chart-distribution-by-hourly-interval"
                      element={<ReportTrafficChartDistributionByHourlyInterval />}
                    />
                    <Route
                      path="traffic/chart-distribution-detailed-total"
                      element={<ReportTrafficChartDistributionDetailedTotal />}
                    />
                    <Route
                      path="traffic/chart-distribution-detailed-direction"
                      element={<ReportTrafficChartDistributionDetailedDirection />}
                    />
                    <Route
                      path="traffic/report-longest-wait-time-list"
                      element={<ReportTrafficLongestWaitTimeList />}
                    />
                    <Route path="report-performance" element={<ReportPerformancePage />} />
                    <Route path="report-out-of-service" element={<ReportOutOfServicePage />} />
                    <Route path="report-traffic" element={<ReportTrafficGeneral />} />
                    <Route path="report-car-user" element={<ReportCarUsagePage />} />
                    <Route path="car-use/chart-by-hour" element={<ReportCarUseChartByHour />} />
                    <Route
                      path="car-use/chart-comparisons"
                      element={<ReportCarUseChartComparisons />}
                    />
                    <Route path="car-use/chart-times" element={<ReportCarUseChartTimes />} />
                    <Route path="report-service" element={<ReportCarServiceGeneral />} />
                    <Route
                      path="car-service/chart-service-log"
                      element={<ReportCarServiceChartServiceLog />}
                    />
                    <Route
                      path="car-service/report-service-log"
                      element={<ReportCarServiceServiceLog />}
                    />
                    <Route path="car-service/report-log" element={<ReportCarServiceLog />} />
                    <Route
                      path="car-service/report-statistics"
                      element={<ReportCarServiceStatistics />}
                    />
                    <Route path="report-beneficial" element={<ReportBeneficialPage />} />
                  </Routes>
                  <GlobalAlert />
                </div>
              </Content>
              {/** ******************************************************* */}
              {/** FOOTER */}
              <Footer className="layout__footerText">
                <span
                  className={isMobile ? "layout__footerTextMobile" : "layout__footerTextDesktop"}
                >
                  © {new Date().getFullYear()} powered by - LiftNet
                </span>
              </Footer>
            </Layout>
          </Layout>
          <GlobalEndpointPanel />
          <Button
            type="primary"
            shape="circle"
            aria-label="Toggle endpoint monitor"
            icon={<FontAwesomeIcon icon={faTerminal} />}
            style={{ position: "fixed", bottom: 16, right: 16, zIndex: 101 }}
            onClick={() => dispatch(updateOpenGlobalEndpointPanel(!openGlobalEndpointPanel))}
          />
        </>
      )}
      {!isLoading && !getCurrentLoggedUserIsLoading && userLogged && userLogged.id && (
        <TermsAndConditions />
      )}
      {!isLoading && !getCurrentLoggedUserIsLoading && !userLogged.id && <UserNotFound />}
      {isLoading && <div style={{ height: "50vh" }} />}
    </Spin>
  );
};

export default App;
